/**
 * Form steps compare offer script
 */
 class FinHub_FormStepsCompareOffer {
  constructor() {
    this.initState();
  }

  initState() {
    this.stepFormCompareWrapper = $('.js-form-compare');
    this.authStepForm = null;

    if (!this.stepFormCompareWrapper.length) {
      return;
    }

    this.mainForm = this.stepFormCompareWrapper.find('form');
    this.initFormCompare();

    if (this.hasAuthStep()) {
      this.authStepForm = new FinHub_FormLoginOrRegister();
    }
  }

  initFormCompare () {
    this.listData = {
      incomes: [],
      liabilities: []
    };
    this.i18n = JSON.parse(JSON.stringify(window.finHubLangs));
    this.prevStepCompare = this.stepFormCompareWrapper.find('.prev-step');
    this.compareProgressBar = this.stepFormCompareWrapper.find('.progress-bar');
    this.compareProgressBarItem = this.compareProgressBar.find('li');
    this.firstStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="0"]');
    this.secondStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="1"]');
    this.thirdStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="2"]');
    this.fourthStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="3"]');
    this.fifthStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="4"]');
    this.lastStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="5"]');
    this.summaryStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="6"]');
    this.firstNextStepCompareBtn = this.firstStepForm.find('.next-step');
    this.secondNextStepCompareBtn = this.secondStepForm.find('.next-step');
    this.thirdNextStepCompareBtn = this.thirdStepForm.find('.next-step');
    this.fourthNextStepCompareBtn = this.fourthStepForm.find('.next-step');
    this.fifthNextStepCompareBtn = this.fifthStepForm.find('.next-step');
    this.submitCompare = this.stepFormCompareWrapper.find('.btn-submit');
    this.currentStep = parseInt(this.stepFormCompareWrapper.attr('data-current-step'), 10);

    this.prevStepCompare.on('click', e => {
      e.preventDefault();
      this.currentStep = parseInt(this.stepFormCompareWrapper.attr('data-current-step'), 10);
      let currentStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="' + this.currentStep +'"]');
      let prevStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="' + (this.currentStep - 1) +'"]');

      this.compareProgressBarItem.eq(this.currentStep).removeClass('active');
      this.compareProgressBarItem.eq(this.currentStep - 1).addClass('active');
      prevStepForm.addClass('active');
      currentStepForm.removeClass('active');
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#progress-bar").offset().top
      }, 100);

      this.currentStep--;
      this.stepFormCompareWrapper.attr('data-current-step', this.currentStep);
    });

    this.initEventListeners();
    this.initListEventListeners();

    let formHelperStep1 = new FinHub_FormHelper(this.firstStepForm);
    let formHelperStep2 = new FinHub_FormHelper(this.secondStepForm);
    let formHelperStep3 = new FinHub_FormHelper(this.thirdStepForm);
    let formHelperStep4 = new FinHub_FormHelper(this.fourthStepForm);
    let formHelperStep5 = new FinHub_FormHelper(this.fifthStepForm);
    let formHelperLastStepForm = new FinHub_FormHelper(this.lastStepForm)

    formHelperStep1.formDependencies([
      {
        useCollection: true,
        field: 'transaction-type-id',
        dependsOn: 'input[name="transaction_type_id"]',
        elementsToShow: (value) => this.firstStepForm.find('[data-transaction-type-id="' + value + '"]')
      },
      {
        field: 'is_need_finishing',
        dependsOn: 'input[name="transaction_type_id"], input[name="transaction_subject_id"]',
        showOn: () => {
          let selectedTransactionType = this.firstStepForm.find('input[name="transaction_type_id"]:checked');

          if (!selectedTransactionType.length) {
            return false;
          }

          let selectedTransactionTypeMarket = selectedTransactionType.eq(0).attr('data-type');
          let selectedSubject = this.firstStepForm.find('input[name="transaction_subject_id"]:checked');

          if (!selectedSubject.length) {
            return false;
          }

          let selectedSubjectNeedFinishing = selectedSubject.eq(0).attr('data-is-need-finishing');

          return selectedTransactionTypeMarket === 'PRIMARY_MARKET' && selectedSubjectNeedFinishing == '1';
        }
      },
      {
        field: 'need_finishing_amount',
        dependsOn: 'input[name="is_need_finishing"]',
        showOn: (value) => value == 1
      }
    ]);

    formHelperLastStepForm.formDependencies([
      {
        field: 'show_banks',
        dependsOn: 'input[name="selected_banks"]',
        showOn: (value) => value == 1
      }
    ]);

    this.firstNextStepCompareBtn.on('click', e => {
      e.preventDefault();
      this.goToNextStep(this.firstStepForm, this.secondStepForm, formHelperStep1, 1);
    });

    this.secondNextStepCompareBtn.on('click', e => {
      e.preventDefault();
      this.goToNextStep(this.secondStepForm, this.thirdStepForm, formHelperStep2, 2);
    });

    this.thirdNextStepCompareBtn.on('click', e => {
      e.preventDefault();
      this.goToNextStep(this.thirdStepForm, this.fourthStepForm, formHelperStep3, 3);
    });

    this.fourthNextStepCompareBtn.on('click', e => {
      e.preventDefault();
      this.goToNextStep(this.fourthStepForm, this.fifthStepForm, formHelperStep4, 4);
    });

    this.fifthNextStepCompareBtn.on('click', e => {
      e.preventDefault();
      this.goToNextStep(this.fifthStepForm, this.lastStepForm, formHelperStep5, 5);
    });

    this.submitCompare.on('click', e => {
      e.preventDefault();
      let result = formHelperLastStepForm.formValidate();
      this.currentStep = 6;

			if (result) {
        this.lastStepForm.addClass('is-loading');

        setTimeout(() => {
          this.lastStepForm.removeClass('is-loading');
          this.compareProgressBarItem.eq(this.currentStep).addClass('active');
          this.lastStepForm.removeClass('active');
          this.summaryStepForm.addClass('active');

          if (this.authStepForm) {
            this.authStepForm.showForm();
          } else {
            let form = this.stepFormCompareWrapper.find('form');

            $.ajax({
              type: 'POST',
              url: form.attr('action'),
              data: form.serialize(),
              success: (data) => {
                console.log(data);
                $('.form-step-summary').removeClass('is-hidden');
                $('.wrapper[data-current-step]').addClass('is-sent-successfully');
              }
            });
          }
        }, 1000);
			}
    });
  }

  hasAuthStep () {
    let authStep = $('.form-with-login-or-register .step-auth[data-url-email-exists]');

    if (authStep.length) {
      return true;
    }

    return false;
  }

  goToNextStep (currentStepForm, nextStepForm, formHelper, step) {
    currentStepForm.find('.next-step-partial-store-error').addClass('is-valid');
    let result = formHelper.formValidate();
    this.currentStep = step;

    if (result) {
      if (step === 3) {
        currentStepForm.find('input[name="incomes[]"]').remove();

        setTimeout(() => {
          for (let i = 0; i < this.listData.incomes.length; i++) {
            let newInput = $('<input type="hidden" name="incomes[]" value="">');
            let incomesData = this.prepareJsonData(this.listData.incomes[i]);
            newInput.val(JSON.stringify(incomesData));
            newInput.appendTo(this.thirdStepForm);
          }

          setTimeout(() => {
            this.partialStore(currentStepForm, nextStepForm);
          }, 0);
        }, 0);

        return;
      }

      if (step === 5) {
        currentStepForm.find('input[name="liabilities[]"]').remove();

        setTimeout(() => {
          for (let i = 0; i < this.listData.liabilities.length; i++) {
            let newInput = $('<input type="hidden" name="liabilities[]" value="">');
            let liabilitiesData = this.prepareJsonData(this.listData.liabilities[i]);
            newInput.val(JSON.stringify(liabilitiesData));
            newInput.appendTo(this.fifthStepForm);
          }

          setTimeout(() => {
            this.partialStore(currentStepForm, nextStepForm);
          }, 0);
        }, 0);

        return;
      }

      setTimeout(() => {
        this.partialStore(currentStepForm, nextStepForm);
      }, 0);
    }
  }

  partialStore (currentStepForm, nextStepForm) {
    currentStepForm.addClass('is-loading');

    $.ajax({
      url: this.mainForm.attr('data-store-partial'),
      type: 'POST',
      data: this.prepareSerializedData(currentStepForm)
    }).done((result) => {
      if (result.success) {
        currentStepForm.removeClass('is-loading');
        this.stepFormCompareWrapper.attr('data-current-step', this.currentStep);
        this.compareProgressBarItem.eq(this.currentStep).addClass('active');
        currentStepForm.removeClass('active');
        nextStepForm.addClass('active');
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#progress-bar").offset().top
        }, 100);
      } else {
        this.storePartialError(currentStepForm);
      }
    }).fail(() => {
      this.storePartialError(currentStepForm);
    });
  }

  storePartialError (stepForm) {
    stepForm.removeClass('is-loading');
    stepForm.find('.next-step-partial-store-error').removeClass('is-valid');
  }

  prepareSerializedData (stepForm) {
    let serializedData = stepForm.find(':input').filter((i, elm) => ($(elm).val() !== '' && $(elm).val() !== null)).serialize();
    serializedData += '&token=' + this.mainForm.find('input[name="token"]').val();
    return serializedData;
  }

  initEventListeners () {
    $(document).on('finhub-add-income', this.addIncome.bind(this));
    $(document).on('finhub-add-income-liability', this.addIncomeLiability.bind(this));
    $(document).on('finhub-add-liability', this.addLiability.bind(this));
  }

  addIncome (e, data) {
    let dataObject = JSON.parse(data);
    dataObject.liabilities = [];
    this.listData.incomes.push(dataObject);
    $('.incomes-list').empty();

    setTimeout(() => {
      this.updateIncomesList();
    }, 0);
  }

  addIncomeLiability (e, data, index) {
    console.log(data, index, this.listData.incomes);
    this.listData.incomes[index].liabilities.push(JSON.parse(data));

    setTimeout(() => {
      this.updateIncomesList();
    }, 0);
  }

  addLiability (e, data) {
    this.listData.liabilities.push(JSON.parse(data));

    setTimeout(() => {
      this.updateLiabilitiesList();
    }, 0);
  }

  initListEventListeners () {
    $('.liabilities-list').on('click', e => {
      e.preventDefault();

      if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#delete-liability') {
        let indexToRemove = parseInt(e.target.getAttribute('data-index'), 10);
        $('.liabilities-list').find('.liabilities-list-item').eq(indexToRemove).remove();
        this.listData.liabilities.splice(indexToRemove, 1);
      }
    });

    $('.incomes-list').on('click', e => {
      e.preventDefault();

      if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#delete-income') {
        let indexToRemove = parseInt(e.target.getAttribute('data-index'), 10);
        this.listData.incomes.splice(indexToRemove, 1);
        this.updateIncomesList();
      }

      if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#delete-income-liability') {
        let indexToRemove = parseInt(e.target.getAttribute('data-index'), 10);
        let subindexToRemove = parseInt(e.target.getAttribute('data-subindex'), 10);
        this.listData.incomes[indexToRemove].liabilities.splice(subindexToRemove, 1);
        this.updateIncomesList();
      }

      if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#add-liability') {
        let indexToUse = parseInt(e.target.getAttribute('data-index'), 10);
        $('.incomes-liabilities-popup').attr('data-index', indexToUse);
        $('.incomes-liabilities-popup').removeClass('is-hidden');
      }
    });
  }

  updateLiabilitiesList () {
    $('.liabilities-list').empty();
    console.log(this.listData.liabilities);

    for (let i = 0; i < this.listData.liabilities.length; i++) {
      let data = this.listData.liabilities[i];
      let newItem = $(`<li class="liabilities-list-item">
        <dl>
          <dt> ` + this.i18n.typecommitment + `:</dt>
          <dd class="data-liability_id"></dd>
          <dt>` + this.i18n.repaid + `:</dt>
          <dd class="data-payoff_amount"></dd>
        </dl>
        <a href="#delete-liability" data-index="" class="link link-red">` + this.i18n.delete + `</a>
      </li>`);

      let liabilityName = window.fhLiabilities[parseInt(data.liability_id, 10)];
      newItem.find('a[data-index]').attr('data-index', i);
      newItem.find('.data-liability_id').text(liabilityName);
      newItem.find('.data-payoff_amount').text(data.payoff_amount);
      newItem.appendTo($('.liabilities-list'));
    }
  }

  updateIncomesList () {
    $('.incomes-list').empty();
    console.log(this.listData.incomes);

    for (let i = 0; i < this.listData.incomes.length; i++) {
      let data = this.listData.incomes[i];
      let incomeType = window.fhIncomeTypes[this.listData.incomes[i].income_type_id];
      let newItem = $(`<li class="incomes-list-item">
        <dl>
          <dt>` + this.i18n.sourceofincome + `:</dt>
          <dd class="data-income_id"></dd>
          <dt>` + this.i18n.untilwhen + `:</dt>
          <dd class="data-date_from"></dd>
        </dl>
        <a href="#delete-income" data-index="" class="link link-red">` + this.i18n.delete + `</a>

        <ul class="incomes-list-item-liabilities"></ul>
        <a href="#add-liability" data-index="" class="btn btn-primary-outline btn-smallest">` + this.i18n.addcommitment + `</a>
      </li>`);

      let incomeName = window.fhIncomes[parseInt(data.income_type_id, 10)];
      newItem.find('a[data-index]').attr('data-index', i);
      newItem.find('.data-income_id').text(incomeName);
      newItem.find('.data-date_from').text(data.date_from);

      if (incomeType !== 'BUSINESS_ACTIVITY') {
        newItem.find('.incomes-list-item-liabilities').remove();
        newItem.find('a[href="#add-liability"]').remove();
      } else {
        for (let j = 0; j < this.listData.incomes[i].liabilities.length; j++) {
          let liabilityData = this.listData.incomes[i].liabilities[j];
          let newLiabilityItem = $(`<li class="incomes-list-item-liabilities-item">
            <dl>
              <dt>` + this.i18n.typecommitment + `:</dt>
              <dd class="data-liability_id"></dd>
              <dt>` + this.i18n.repaid + `</dt>
              <dd class="data-payoff_amount"></dd>
            </dl>
            <a href="#delete-income-liability" data-index="" class="link link-red">` + this.i18n.delete + `</a>
          </li>`);

          let liabilityName = window.fhIncomeLiabilities[parseInt(liabilityData.liability_id, 10)];
          newLiabilityItem.find('a[data-index]').attr('data-index', i);
          newLiabilityItem.find('.data-liability_id').text(liabilityName);
          newLiabilityItem.find('.data-payoff_amount').text(liabilityData.payoff_amount);
          newLiabilityItem.appendTo(newItem.find('.incomes-list-item-liabilities'));
        }
      }

      newItem.appendTo($('.incomes-list'));
    }
  }

  prepareJsonData (input) {
    input = JSON.parse(JSON.stringify(input));
    let keys = Object.keys(input);

    for (let i = 0; i < keys.length; i++) {
      if (input[keys] === '' || input[keys] === null) {
        delete input[keys];
      }
    }

    return input;
  }
}
